import React from 'react';
export var Name = function (_a) {
    var children = _a.children;
    return (React.createElement("h2", { className: "font-header text-body text-md font-normal mb-0" }, children));
};
Name.displayName = 'Card.Name';
